<div class="fixed bottom-4 right-4 z-[9999] flex flex-col-reverse gap-3">
  @for (notification of notifications; track notification.id) {
    <div class="flex items-start justify-between gap-3 w-full rounded-md border-b-4 p-4 shadow-theme-sm transition-all duration-300"
         [ngClass]="{
              'sm:max-w-[420px]': notification.type === 'error',
              'sm:max-w-[340px]': notification.type !== 'error',
              'border-success-500 bg-white dark:bg-[#1E2634]': notification.type === 'success',
              'border-danger-500 bg-red-50 dark:bg-red-950/50': notification.type === 'error',
              'border-warning-500 bg-white dark:bg-[#1E2634]': notification.type === 'warning',
              'border-info-500 bg-white dark:bg-[#1E2634]': notification.type === 'info'
            }"
    >
      <div class="flex items-center gap-4">
        <div class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg text-success-600 dark:text-success-500 bg-success-50 dark:bg-success-500/[0.15]">
          @switch (notification.type) {
            @case ('success') {
              <lucide-icon [name]="CheckCircle2" class="h-5 w-5 text-success-500" />
            }
            @case ('error') {
              <lucide-icon [name]="AlertCircle" class="h-5 w-5 text-danger-500" />
            }
            @case ('warning') {
              <lucide-icon [name]="AlertTriangle" class="h-5 w-5 text-warning-500" />
            }
            @case ('info') {
              <lucide-icon [name]="Info" class="h-5 w-5 text-info-500" />
            }
          }
        </div>

        <div class="flex flex-col gap-1 min-w-0">
          @if (notification.title) {
            <h4 class="sm:text-sm text-xs font-semibold text-gray-900 dark:text-white/90">
              {{ notification.title }}
            </h4>
          }
          <p class="sm:text-sm text-xs text-gray-700 dark:text-gray-300 break-words">
            {{ notification.message }}
          </p>
        </div>
      </div>

      <button (click)="close(notification.id)" class="text-gray-400 hover:text-gray-800 dark:hover:text-white/90">
        <lucide-icon [name]="X" class="h-5 w-5"></lucide-icon>
      </button>
    </div>
  }
</div>
